import { render, staticRenderFns } from "./screenCard.vue?vue&type=template&id=1524ca2d&scoped=true&"
import script from "./screenCard.vue?vue&type=script&lang=js&"
export * from "./screenCard.vue?vue&type=script&lang=js&"
import style0 from "./screenCard.vue?vue&type=style&index=0&id=1524ca2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524ca2d",
  null
  
)

export default component.exports